export const MASTER_NOTE_CONTENT_MIN_WIDTH = 360;
export const MASTER_NOTE_CONTENT_MAX_WIDTH = 1000;
export const MASTER_NOTE_NAV_MIN_WIDTH = 160;
export const MASTER_NOTE_NAV_INIT_WIDTH = 240;
export const MASTER_NOTE_NAV_MAX_WIDTH = 320;
